var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 61.4766C27.3547 61.4766 31.9297 56.9016 31.9297 51.2305V40.9844H21.6836C16.0125 40.9844 11.4375 45.5594 11.4375 51.2305C11.4375 56.9016 16.0125 61.4766 21.6836 61.4766Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 30.7383C11.4375 25.0672 16.0125 20.4922 21.6836 20.4922H31.9297V40.9844H21.6836C16.0125 40.9844 11.4375 36.4094 11.4375 30.7383Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 10.2461C11.4375 4.575 16.0125 0 21.6836 0H31.9297V20.4922H21.6836C16.0125 20.4922 11.4375 15.9172 11.4375 10.2461Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9297 0H42.1758C47.8469 0 52.4219 4.575 52.4219 10.2461C52.4219 15.9172 47.8469 20.4922 42.1758 20.4922H31.9297V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4219 30.7383C52.4219 36.4094 47.8469 40.9844 42.1758 40.9844C36.5047 40.9844 31.9297 36.4094 31.9297 30.7383C31.9297 25.0672 36.5047 20.4922 42.1758 20.4922C47.8469 20.4922 52.4219 25.0672 52.4219 30.7383Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61.488,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.9355e7feeefbb6e61be56fbcf755d432.svg";
export { ForwardRef as ReactComponent };